import { render } from "./Topnav.vue?vue&type=template&id=7587a1e3"
import script from "./Topnav.vue?vue&type=script&lang=js"
export * from "./Topnav.vue?vue&type=script&lang=js"
script.render = render

export default script